var ITEM_CLICK = {
    EXPAND: 'expand',
    LINK: 'link',
    NOTHING: 'nothing',
    FULLSCREEN: 'fullscreen',
    MAGNIFY: 'magnify',
};
export default ITEM_CLICK;
//# sourceMappingURL=itemClick.js.map